import getSymbolFromCurrency from "@dcspark/currency-symbol-map";
import { t } from "i18next";
import { tokens } from "~/locales/tokens";
import { GetOperationalNotificationsQuery } from "~/types/__generated/gql/graphql";
import { formatNumber } from "~served/utils/misc";

type PaywayOrderFailureNotification = Pick<
	GqlResultOf<GetOperationalNotificationsQuery>[number],
	"_temp_order"
> & { _location: { name: string } };

const { paywayOrderFailure } = tokens.notifications;

const MESSAGE_TOKENS = {
	checkout_not_completed: paywayOrderFailure.checkoutNotCompleted,
	payment_failed: paywayOrderFailure.paymentFailed,
	postback_not_received: paywayOrderFailure.postbackNotReceived,
	processing_failed: paywayOrderFailure.processingFailed,
	status_unknown: paywayOrderFailure.statusUnknown,
};

export const getPaywayOrderFailureMessage = ({
	_location,
	_temp_order,
}: PaywayOrderFailureNotification) => {
	if (_temp_order?._payment_amount == null || !_temp_order._payment_currency) {
		return _location.name;
	}

	const hasCreatedOrder = _temp_order._order_index != null;
	// Notifications raised before `failure_reason` existed only know whether the payment was approved.
	const reason =
		_temp_order.failure_reason ??
		(_temp_order._is_payment_approved ? "processing_failed" : "payment_failed");

	return t(MESSAGE_TOKENS[reason], {
		amount: formatNumber(_temp_order._payment_amount),
		currency:
			getSymbolFromCurrency(_temp_order._payment_currency) ??
			_temp_order._payment_currency,
		place: hasCreatedOrder
			? t(paywayOrderFailure.placeWithOrder, {
					location: _location.name,
					index: _temp_order._order_index,
				})
			: _location.name,
		ending: t(
			hasCreatedOrder
				? paywayOrderFailure.orderNotMarkedPaid
				: paywayOrderFailure.orderNotCreated,
		),
	});
};
